// TO DO: MOVE THIS TO REWARDS PAGE ONLY
/*============================================================================
Yotpo Logged In State Fix
==============================================================================*/
if(window.location.href.indexOf("loyalty-reward") > -1) {
   function waitForElement(id, callback){
    var loops = setInterval(function(){
        if(document.querySelector(id)){
            clearInterval(loops);
            callback();
        }
    }, 100);
  }

  function yotpo_logged_in_fix(){
    try{
        console.log("customer logged in; attempting fix now")
        var logged_in_state = document.querySelector(".loyalty-logged-in-state")
        if (logged_in_state){
            var hero_section = document.querySelectorAll(".yotpo-widget-hero-section")
            
            hero_section[0].style.display = "none"
          hero_section[1].style.display = 'none'
            var yotpo_referral_background = document.querySelector(".yotpo-center-background")
            yotpo_referral_background.style.height = "75vh"
        } else{
        var hero_section_background = document.querySelector(".yotpo-text-on-background")
            hero_section_background.style.minHeight = "400px"
            var yotpo_center_layout = document.querySelector(".yotpo-center-layout")
            yotpo_center_layout.style.top = "75px"
            yotpo_center_layout.style.paddingBottom = "75px"
            var yotpo_referral_background = document.querySelector(".yotpo-center-background")
            yotpo_referral_background.style.height = "70vh"
        }
      } catch(e){
        // console.log("customer not logged in")
        // console.log(e)
      }
  }

  waitForElement(".yotpo-widget-hero-section",yotpo_logged_in_fix);
  
}